import { dataOrder } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOrder = /*#__PURE__*/createIcon(dataOrder)
export default IconOrder
